import { Link, useNavigate } from "react-router-dom";
import Arrow from "../../../Helpers/icons/Arrow";
import Selectbox from "../../../Helpers/Selectbox";
import Instagram from "../../../Helpers/icons/Instagram";
import Facebook from "../../../Helpers/icons/Facebook";
import { facebookLink, instagramLink, tiktokLink, youtubeLink } from "../../../../utils";
import Youtube from "../../../Helpers/icons/Youtube";
import Tiktok from "../../../Helpers/icons/Tiktok";

export default function TopBar({ className, userTypes }) {

  const navigate = useNavigate();

  return (
    <>
      <div
        style={{ backgroundColor: '#f7f7f7' }}
        className={`w-full bg-white h-10 border-b border-qgray-border ${className || ""
          }`}
      >
        <div className="container-x mx-auto h-full">
          <div className="flex justify-between items-center h-full">
            <div className="topbar-nav">
              <ul className="flex space-x-3 lg:space-x-6 items-center">
                <li>
                  <a href={instagramLink} target="blank">
                    <Instagram className="fill-current text-[#E4405F] hover:text-[#d62976]" />
                  </a>
                </li>
                <li>
                  <a href={facebookLink} target="blank">
                    <Facebook className="fill-current text-[#1877F2] hover:text-[#155ec1]" />
                  </a>
                </li>
                <li>
                  <a href={youtubeLink} target="blank">
                    <Youtube className="fill-current text-[#FF0000] hover:text-[#cc0000]" />
                  </a>
                </li>
                <li>
                  <a href={tiktokLink} target="blank">
                    <Tiktok className="fill-current text-[#000000] hover:text-[#000000]" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="topbar-nav">
              <ul className="flex space-x-2 lg:space-x-6">
                <li style={{ cursor: 'pointer' }} onClick={() => { navigate(`/register?type=${userTypes.find(e => e.label === 'Supplier')?.value}`) }}>
                  <span className="text-[10px] lg:text-xs leading-6 text-qblack font-500">
                    <span className="hidden sm:inline">Be a </span>Supplier
                  </span>
                </li>
                <li style={{ cursor: 'pointer' }} onClick={() => { navigate(`/register?type=${userTypes.find(e => e.label === 'Manufacturer')?.value}`) }}>
                  <span className="text-[10px] lg:text-xs leading-6 text-qblack font-500">
                    <span className="hidden sm:inline">Be a </span>Manufacturer
                  </span>
                </li>
                <li style={{ cursor: 'pointer' }} onClick={() => { navigate(`/register?type=${userTypes.find(e => e.label === 'Drop Shipper')?.value}`) }}>
                  <span className="text-[10px] lg:text-xs leading-6 text-qblack font-500">
                    <span className="hidden sm:inline">Be a </span>Dropshipper
                  </span>
                </li>
              </ul>
            </div>
            {/* <div className="topbar-dropdowns sm:block hidden">
              <div className="flex space-x-6">
                <div className="country-select flex space-x-1 items-center">
                  <div>
                    <img
                src={`${process.env.PUBLIC_URL}/assets/images/country-logo-16x16.png`}
                      width="16"
                      height="16"
                      alt="country logo"
                      className="overflow-hidden rounded-full"
                    />
                  </div>
                  <Selectbox
                    className="w-fit"
                    datas={["United State", "Bangladesh", "India"]}
                  />
                  <div>
                    <Arrow className="fill-current qblack" />
                  </div>
                </div>
                <div className="currency-select flex space-x-1 items-center">
                  <Selectbox className="w-fit" datas={["USD", "BDT"]} />
                  <Arrow className="fill-current qblack" />
                </div>
                <div className="language-select flex space-x-1 items-center">
                  <Selectbox className="w-fit" datas={["Bangla", "english"]} />
                  <Arrow className="fill-current qblack" />
                </div>
              </div>
            </div> */}
          </div >
        </div >
      </div >
    </>
  );
}
